<template>
  <div class="pb-80">
    <router-view />
  </div>
</template>

<script lang="ts">

export default {
  name: 'SitterOnboarding',
  watch: {
    // Watch for route changes to update focus
    // If you don't do this, keyboard navigation will be forced into footer links
    $route() {
      this.focusFirstInteractive();
    },
  },
  methods: {
    focusFirstInteractive() {
      // Use nextTick to ensure DOM is fully updated
      this.$nextTick(() => {
        const firstInteractive = this.$el.querySelector('input, button, a[href], textarea, select, [tabindex="0"]');
        if (firstInteractive) {
          firstInteractive.focus();
        }
      });
    },
  },
};
</script>
